import Model, { attr, belongsTo } from '@ember-data/model';
import type TeamConversationModel from 'uplisting-frontend/models/team-conversation';

export default class TeamConversationLinkModel extends Model {
  @attr('string') resourceType!: string;
  @attr('string') resourceId!: string;
  @attr('boolean') anchor!: boolean;
  @attr('string') label?: string | null;

  @belongsTo('team-conversation', {
    async: false,
    inverse: 'teamConversationLinks',
  })
  teamConversation!: TeamConversationModel;
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'team-conversation-link': TeamConversationLinkModel;
  }
}
